// Event Record actions
export const EVENT_RECORD_REQUEST = 'EVENT_RECORD_REQUEST';
export const EVENT_RECORD_REQUEST_SUCCESS = 'EVENT_RECORD_REQUEST_SUCCESS';
export const EVENT_RECORD_REQUEST_FAILURE = 'EVENT_RECORD_REQUEST_FAILURE';
export const EVENT_RECORD_CREATE = 'EVENT_RECORD_CREATE';
